import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 3V19.0357L15.3757 19.0358L11.9939 21.8375L8.65157 19.0358H3.00195V3.00003L21.002 3ZM16.164 9.25L14.7498 7.83579L11.2498 11.3358L9.74976 9.83579L8.33554 11.25L11.2498 14.1642L16.164 9.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleCheck;
